import { createSelector } from 'reselect'

/** A Redux selector to retrieve User first name
 * @param state - The Redux state
 * @param {String} - First Name
 */

const getUser = (state: any) => state.user && state.user.data

export const selectFirstName = createSelector(
  getUser,
  (data) => data && data.firstName ? data.firstName : null
)

/** A Redux selector to retrieve User last name
 * @param state - The Redux state
 * @param {String} - Last Name
 */

export const selectLastName = createSelector(
  getUser,
  (data) => data && data.lastName ? data.lastName : null
)

/** A Redux selector to retrieve User email
 * @param state - The Redux state
 * @param {String} - Email
 */

export const selectEmail = createSelector(
  getUser,
  (data) => data && data.email ? data.email : null
)
